import axios from '@axios'

const state = () => ({
  plans: [],
  catalog: [],
  requests: [],
  myMembership: null,
  loading: false,
})

const getters = {
  membershipPlans(state) {
    return state.plans
  },
  membershipCatalog(state) {
    return state.catalog
  },
  membershipRequests(state) {
    return state.requests
  },
  membershipsLoading(state) {
    return state.loading
  },
  // El payload del login se queda viejo en cuanto el admin mueve el plan o el cliente crea
  // una obra, asi que manda lo que se pidio a /v1/membership y solo se cae al login si
  // todavia no llega.
  currentMembership(state, _getters, rootState, rootGetters) {
    return state.myMembership || rootGetters['auth/currentUser']?.customer?.membership || null
  },
}

const mutations = {
  loading: (state, payload) => {
    state.loading = payload
  },
  SET_PLANS(state, payload) {
    state.plans = payload
  },
  SET_CATALOG(state, payload) {
    state.catalog = payload
  },
  SET_PLAN(state, payload) {
    state.plans = state.plans.map(plan => (plan.id === payload.id ? payload : plan))
  },
  SET_REQUESTS(state, payload) {
    state.requests = payload
  },
  SET_MY_MEMBERSHIP(state, payload) {
    state.myMembership = payload
  },
  SET_REQUEST(state, payload) {
    state.requests = state.requests.map(request => (request.id === payload.id ? payload : request))
  },
}

const actions = {
  getMembershipPlans(context) {
    context.commit('loading', true)
    return axios
      .get('/v1/membership_plans')
      .then(response => {
        context.commit('SET_PLANS', response.data.data)
        context.commit('SET_CATALOG', response.data.catalog)
        return response.data
      })
      .finally(() => context.commit('loading', false))
  },

  updateMembershipPlan(context, plan) {
    context.commit('loading', true)
    return axios
      .put(`/v1/membership_plans/${plan.id}`, {
        membership_plan: {
          name: plan.name,
          tagline: plan.tagline,
          price: plan.price,
          active: plan.active,
          purchasable: plan.purchasable,
          position: plan.position,
          features: plan.features,
        },
      })
      .then(response => {
        context.commit('SET_PLAN', response.data)
        return response.data
      })
      .finally(() => context.commit('loading', false))
  },

  getMyMembership(context) {
    return axios
      .get('/v1/membership')
      .then(response => {
        context.commit('SET_MY_MEMBERSHIP', response.data.data)
        return response.data.data
      })
      .catch(() => null)
  },

  getMembershipRequests(context, params) {
    context.commit('loading', true)
    return axios
      .get('/v1/membership_requests', { params })
      .then(response => {
        context.commit('SET_REQUESTS', response.data.data)
        return response.data
      })
      .finally(() => context.commit('loading', false))
  },

  createMembershipRequest(context, payload) {
    context.commit('loading', true)
    return axios
      .post('/v1/membership_requests', { membership_request: payload })
      .then(response => response.data)
      .finally(() => context.commit('loading', false))
  },

  approveMembershipRequest(context, requestId) {
    context.commit('loading', true)
    return axios
      .put(`/v1/membership_requests/${requestId}/approve`)
      .then(response => {
        context.commit('SET_REQUEST', response.data)
        return response.data
      })
      .finally(() => context.commit('loading', false))
  },

  rejectMembershipRequest(context, { requestId, rejectReason }) {
    context.commit('loading', true)
    return axios
      .put(`/v1/membership_requests/${requestId}/reject`, { reject_reason: rejectReason })
      .then(response => {
        context.commit('SET_REQUEST', response.data)
        return response.data
      })
      .finally(() => context.commit('loading', false))
  },

  updateCustomerMembership(context, { customerId, planKey, months }) {
    return axios
      .put(`/v1/customers/${customerId}/membership`, { plan_key: planKey, months })
      .then(response => response.data)
  },

  cancelCustomerMembership(context, { customerId }) {
    return axios
      .delete(`/v1/customers/${customerId}/membership`)
      .then(response => response.data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
